import React, { useState, useRef, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { apiUrl,brands } from "../../../config/config";


const SearchBar = ({ mobile = false }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const navigate = useNavigate();
  const containerRef = useRef(null); // ⬅ ref for detecting outside click

  // --------------------------
  // CLOSE DROPDOWN ON OUTSIDE CLICK
  // --------------------------
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setResults([]);
        setSearched(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearch = async (value) => {
    setQuery(value);

    if (value.trim().length < 2) {
      setResults([]);
      setSearched(false);
      return;
    }

    try {
      const res = await fetch(`${apiUrl}/api/${brands}/products/search?query=${value}`);
      const data = await res.json();

      setSearched(true);

      if (data.data && data.data.length > 0) {
        setResults(data.data);
      } else {
        setResults([]);
      }
    } catch (err) {
      console.log("Search error:", err);
    }
  };

  const selectProduct = (product) => {
    navigate(
      `/product/${product.category.category_name.replace(/\s+/g, "-")}/${product.category_id}/${product.name.replace(/\s+/g, "-")}/${product.id}`
    );

    setResults([]);
    setQuery("");
    setSearched(false);
  };

  return (
    <div
  ref={containerRef}
  className={`relative w-full ${mobile ? "" : "max-w-[480px]"}`}
>
  <div className="relative flex h-[40px] w-full items-center overflow-hidden rounded-[6px] bg-[#f6f7f9] shadow-[0_2px_8px_rgba(0,0,0,0.08)] sm:h-[50px]">
    <input
      type="text"
      placeholder="Search the store"
      value={query}
      onChange={(e) => handleSearch(e.target.value)}
      className="h-full w-[calc(100%-52px)] bg-transparent px-[16px] text-[14px] font-normal text-[#6f6f6f] outline-none placeholder:text-[#6f6f6f] sm:text-[18px]"
    />

    <button
      type="button"
      className="flex h-full w-[50px] shrink-0 items-center justify-center bg-[#242424] text-white transition-all duration-300 hover:bg-[#111111]"
    >
      <FaSearch className="text-[21px] sm:text-[23px]" />
    </button>
  </div>

      {(results.length > 0 || searched) && query.length >= 2 && (
        <div className="absolute left-0 w-full bg-white shadow-lg border rounded-md mt-2 z-50 max-h-72 overflow-y-auto">
          {results.length > 0 ? (
            results.map((item) => (
              <div
                key={item.id}
                className="flex items-center p-3 gap-3 hover:bg-gray-100 cursor-pointer"
                onClick={() => selectProduct(item)}
              >
                <img
                  src={`${apiUrl}/storage/${item.image}`}
                  className="w-10 h-10 object-cover rounded"
                  alt=""
                />
                <div>
                  <p className="font-semibold text-sm">{item.name}</p>
                  <p className="text-xs text-gray-500">
                    {item.category.category_name}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <div className="p-4 text-center text-gray-500 text-sm">
              No products found
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default SearchBar;
